// generated from 1_039 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const anyLinkClickedFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("any_link_clicked_filter"),
  comparison_key: z.enum([
    "7", // 812 (78.15%)
    "8", // 227 (21.85%)
  ]),
  display_name: z.string(),
  // undefined: 405 (38.98%), defined 634 (61.02%)
  raw_value: z
    .object({
      link_id: common.objectId,
      // avg: 2441.74, min: 1, max: 39246
      short_id: z.int().min(1),
    })
    .optional(),
  value: z.object({
    id: z.object({
      link_id: common.objectId,
      // avg: 1639.75, min: 1, max: 39246
      short_id: z.int().min(1),
    }),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
